<div>
    <sag-ui-button [menuOffsetTop]="12" sag-ui-menu-trigger [menuTriggerFor]="label" color="tertiary"
        ><span class="flex items-center gap-2">{{ label }}<span class="icon-chevron-down"></span></span>
    </sag-ui-button>
    <sag-ui-menu [menu]="label" class="max-h-72">
        @for (value of values; track $index) {
        <sag-ui-menu-item (click)="select(value)"
            ><span
                [attr.data-selected]="selected.includes(value)"
                class="text-shs-white-1 data-[selected=true]:text-shs-orange"
                >{{ value }}</span
            ></sag-ui-menu-item
        >
        }
    </sag-ui-menu>
</div>
